import { BannerModel } from "@/types/banner";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const Banner = ({ banner }: { banner: BannerModel }) => {
  return (
    <div className="p-1">
      {banner.link || banner.product_slug ? (
        <Link
          href={
            banner.type === "ad"
              ? banner.link
              : `/products/${banner.product_slug}`
          }
          className="relative flex h-[200px] md:h-[300px]  items-center justify-center rounded-lg overflow-hidden"
          target={banner.type === "ad" ? "_blank" : ""}
        >
          <Image
            className="absolute object-cover"
            fill
            src={banner.image}
            alt=""
          />
        </Link>
      ) : (
        <div className="relative flex h-[200px] md:h-[300px]  items-center justify-center rounded-lg overflow-hidden">
          <Image
            className="absolute object-cover"
            fill
            src={banner.image}
            alt=""
          />
        </div>
      )}
    </div>
  );
};

export default Banner;
